import { MoreVertical } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconMoreVertical(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <MoreVertical />
    </IconWrapper>
  );
}
